import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import PrimarySocials from '../components/PrimarySocials';
import SecondarySocials from '../components/SecondarySocials';
import CentralForm from '../components/CentralForm';
import AppBlock from '../components/AppBlock';
import Footer, {bindPaths, PATHS} from '../components/Footer';
import ResendConfirm from '../components/Form/ResendConfirm';
import {pathByLabel} from '../utils/urlPaths';

class Home extends Component {
  render() {
    const {xl, mode, showRememberMe, auth} = this.props;
    const socialLinks = xl.socialLinks || {};

    const hasAdditionalSocialsToShow =
      socialLinks.secondary.length > 0 || socialLinks.other.length > 0;

    if (auth.resend.isResend) {
      return <ResendConfirm location={this.props.location} />;
    }

    return (
      <React.Fragment>
        {mode.header.length > 0 && <Footer appearance="top" links={bindPaths(...mode.header)} />}
        <AppBlock className="block-home">
          {mode.primarySocials &&
            socialLinks.primary.length > 0 && (
              <PrimarySocials className="app-block__item" socials={socialLinks.primary} />
            )}

          {mode.username && (
            <CentralForm
              className="app-block__item"
              showRememberMe={showRememberMe}
              location={this.props.location}
            />
          )}

          {mode.secondarySocials &&
            hasAdditionalSocialsToShow && (
              <div className="app-block__item bottom-area">
                <SecondarySocials
                  allowedSocials={socialLinks.secondary}
                  hiddenSocials={socialLinks.other}
                  otherSocialLink={mode.otherSocialLink}
                />
              </div>
            )}
        </AppBlock>
        {mode.footer.length > 0 && <Footer links={bindPaths(...mode.footer)} />}
      </React.Fragment>
    );
  }
}

Home.propTypes = {
  mode: PropTypes.shape({
    header: PropTypes.array.isRequired,
    primarySocials: PropTypes.bool.isRequired,
    username: PropTypes.bool.isRequired,
    secondarySocials: PropTypes.bool.isRequired,
    footer: PropTypes.array.isRequired,
    otherSocialLink: PropTypes.string
  }).isRequired,
  showRememberMe: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  xl: PropTypes.object.isRequired
};

Home.defaultProps = {
  mode: {
    header: [],
    primarySocials: true,
    username: true,
    secondarySocials: true,
    otherSocialLink: pathByLabel[PATHS.OTHER_SOCIALS],
    footer: [PATHS.FORGOT_PASSWORD, PATHS.CREATE_ACCOUNT]
  }
};

export default connect(state => state)(Home);



// WEBPACK FOOTER //
// ./pages/Home.jsx